import { useContext } from 'react';
import { AnalyticsContext } from '../analytics/AnalyticsContext';
import AnalyticsService from '../analytics/Analytics';

const useAnalytics = (): AnalyticsService => {
  const analytics = useContext(AnalyticsContext);

  if (!analytics) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return analytics;
};

export default useAnalytics;
